var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-open-file",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico-open-file"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    style: {
      visibility: "hidden",
      opacity: 0,
      fill: "#FFFFFF"
    },
    width: 96,
    height: 96
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M94.816,51.899L75.771,84.074C74.339,86.495,71.7,88,68.886,88H26.667c0-0.004-4.614-0.004-4.614-0.004 L26.667,80c0.002,0,42.219,0,42.219,0L86.14,50.854l-52.023,0.14L17.851,82.811c-1.633,3.267-4.818,5.195-8.322,5.195 c-0.744,0-1.503-0.087-2.264-0.267C2.919,86.714,0,83.025,0,78.561V18.375c0-3.86,3.14-7,7-7l25.562-0.033 c2.651,0,5.032,1.458,6.235,3.809L41.395,20H68c4.411,0,8,3.589,8,8v8.5h-8V28H36.605l-4.638-8.657L8,19.374v59.187 c0,0.937,0.599,1.274,1.102,1.393c0.503,0.12,1.19,0.084,1.609-0.753l16.283-31.849c1.371-2.681,4.092-4.35,7.101-4.358 l55.54-0.149c2.163,0,4.158,1.156,5.225,3.021C95.93,47.733,95.913,50.046,94.816,51.899z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFile);
export default __webpack_public_path__ + "static/media/open-file.c87d550087948f317122efc2fea67710.svg";
export { ForwardRef as ReactComponent };